var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({staticClass:"px-4 py-2 rounded-lg font-normal shadow transition-shadow hover:shadow-md duration-200 focus:outline-none",class:[
    {
      'bg-gray-900 text-white': _vm.variant === 'primary'
    },
    {
      'bg-white text-gray-600 hover:text-gray-700': _vm.variant === 'secondary'
    }
  ]},_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }